export default __webpack_public_path__ + "static/media/bfc-capital-text.1721036b.png";